export default {"src":"/_next/static/media/cs-logo-desktop.f18ce186.svg","height":39,"width":198,"blurWidth":0,"blurHeight":0};